"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SummatedComponent_1 = require("./SummatedComponent");
var SummatedComponentStyle_1 = require("../../components/SummatedComponentStyle");
var summatedStyle = SummatedComponentStyle_1.default(true);
var ExplanationComponent = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("p", null,
        React.createElement("strong", null, "Background")),
    React.createElement("p", null,
        "The ",
        React.createElement("strong", null,
            React.createElement("em", null, "Tops with Attempts")),
        " is a simple format that tracks the number of Tops that the climber achieves and the number of attempts taken to earn those Tops."),
    React.createElement("p", null,
        React.createElement("strong", null, "Explanation")),
    React.createElement("p", null,
        "For the ",
        React.createElement("em", null, "Tops with Attempts"),
        " format, climbers will have to reach and achieve stable control of the \"Top\" holds within each problem. Attempts to reach the holds are also recorded, and the order of scoring is:"),
    React.createElement("ol", null,
        React.createElement("li", null, "Number of Tops"),
        React.createElement("li", null, "Number of attempts to achieve Tops in (1)")),
    React.createElement("p", null, "The aim is to get the most Tops in the least attempts!"),
    React.createElement("p", null,
        React.createElement("strong", null, "Example")),
    React.createElement("span", null,
        "Climber's result: ",
        React.createElement("em", null,
            React.createElement(SummatedComponent_1.default, { summated: { top: 3, topAttempt: 8, display: '' }, style: summatedStyle }))),
    React.createElement("p", null,
        "For the above result, the climber scored a total of 4 Tops ",
        React.createElement("em", null, "(T)"),
        " and took a total of 8 attempts to achieve those tops."))); };
exports.default = ExplanationComponent;
//# sourceMappingURL=ExplanationComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/TopsWithAttempts/ExplanationComponent.js
// module id = 1033
// module chunks = 0